export const getApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '99358d789amsh428df3c6452e0bdp131a2ejsnaf244ef5da8e',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_OPTIONS = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "39f939c5c90b7c99a037f6f73e21b37b";

